import { createFileRoute, redirect } from "@tanstack/react-router";

import { HomePageRoute } from "../components/home/HomePageRoute";
import { SpacePage } from "../components/spaces/SpacePage";
import { parseSpaceView, spaceViewSearch, type SpaceSearch } from "../components/spaces/SpacePage.logic";

/**
 * `/$org/spaces/$spaceId` — one space's overview: workflows, its chats, its
 * files with their history, its policies and procedures, and what changed.
 * `?doc=` opens one of its documents in place, `?settings=1` its settings.
 * Beside Home's sidebar like the list, with the rail on Spaces
 * (components/home/homePaths).
 */
function SpaceRouteView() {
  const { spaceId } = Route.useParams();
  const search = Route.useSearch();
  const view = parseSpaceView(search);
  return (
    <HomePageRoute>
      <SpacePage key={spaceId} spaceId={spaceId} view={view} />
    </HomePageRoute>
  );
}

export const Route = createFileRoute("/$org/spaces/$spaceId")({
  validateSearch: (search: Record<string, unknown>): SpaceSearch => spaceViewSearch(parseSpaceView(search)),
  beforeLoad: async ({ context }) => {
    if (
      context.authGateState.status !== "authenticated" &&
      context.authGateState.status !== "hosted-static"
    ) {
      throw redirect({ to: "/pair", replace: true });
    }
  },
  component: SpaceRouteView,
});
